export const RESET = 'containers/UserProvider/RESET';
export const SUBMIT_USER = 'containers/UserProvider/SUBMIT_USER';
export const SUBMIT_USER_FAIL = 'containers/UserProvider/SUBMIT_USER_FAIL';
export const SUBMIT_USER_SUCCESS = 'containers/UserProvider/SUBMIT_USER_SUCCESS';
export const SET_USER = 'containers/UserProvider/SET_USER';
export const GET_USER = 'containers/UserProvider/GET_USER';
export const RESTORE_USER = 'containers/UserProvider/RESTORE_USER';
export const CHANGE_INPUT = 'containers/UserProvider/CHANGE_INPUT';
